// Barre d'achat collante : visible quand le bouton d'ajout au panier de la fiche produit est sorti de l'écran
// par le haut. Suit la variante choisie (prix, rupture, menus de variantes). Le bouton remonte au produit ou clique le vrai bouton
// d'ajout de Dawn (même formulaire, même tiroir panier, apps comprises).
if (!customElements.get('dx-sticky-atc')) {
  customElements.define(
    'dx-sticky-atc',
    class DxStickyAtc extends HTMLElement {
      connectedCallback() {
        this.productInfo = document.querySelector('product-info[id^="MainProduct-"]');
        this.button = this.querySelector('.dx-sticky-atc__button');
        if (!this.productInfo || !this.button) return;
        this.mainButton = this.productInfo.querySelector('button[name="add"]');
        this.target = this.mainButton || this.productInfo;

        this.button.addEventListener('click', () => this.onClick());
        this.selects = Array.from(this.querySelectorAll('[data-dx-option]'));
        this.selects.forEach((select) => select.addEventListener('change', () => this.selectOption(select.value)));

        // Vérifié à chaque défilement (une fois par frame) : un défilement rapide peut faire passer le bouton
        // d'en dessous à au-dessus de l'écran sans qu'un IntersectionObserver ne le voie se croiser.
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            const passed = this.target.getBoundingClientRect().bottom < 0;
            if (passed !== this.classList.contains('is-visible')) this.toggle(passed);
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.productInfo.dataset.section) return;
            this.update(event.data.variant);
            this.syncOptions();
          });
        }
      }

      disconnectedCallback() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        this.unsubscribe?.();
        document.documentElement.classList.remove('dx-sticky-atc-on');
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
        this.setAttribute('aria-hidden', String(!show));
        document.documentElement.classList.toggle('dx-sticky-atc-on', show);
        if (show) document.documentElement.style.setProperty('--dx-sticky-atc-h', `${this.offsetHeight}px`);
      }

      onClick() {
        if (this.dataset.action === 'add' && this.mainButton && !this.mainButton.disabled) {
          this.mainButton.click();
          return;
        }
        const top = this.productInfo.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      }

      // Choix dans la barre : on coche la même valeur dans le sélecteur de variantes de Dawn (bouton, pastille
      // ou liste), qui fait tout le reste (prix, stock, URL, formulaire) et nous renvoie variantChange.
      selectOption(valueId) {
        const input = this.productInfo.querySelector(`variant-selects [data-option-value-id="${valueId}"]`);
        if (!input) return;
        if (input.tagName === 'OPTION') {
          const select = input.closest('select');
          select.value = input.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      syncOptions() {
        if (!this.selects.length) return;
        const picker = this.productInfo.querySelector('variant-selects');
        if (!picker) return;
        const groups = picker.querySelectorAll('fieldset, .product-form__input--dropdown');
        groups.forEach((group, index) => {
          const select = this.selects[index];
          const checked = group.querySelector('input:checked') || group.querySelector('select')?.selectedOptions[0];
          if (select && checked?.dataset.optionValueId) select.value = checked.dataset.optionValueId;
        });
      }

      update(variant) {
        const price = this.querySelector('[data-dx-price]');
        const compare = this.querySelector('[data-dx-compare]');
        if (!variant) {
          if (this.dataset.action === 'add') this.setButton(false);
          return;
        }
        if (price) price.textContent = this.formatMoney(variant.price);
        this.updateImage(variant.featured_media);
        if (compare) {
          const onSale = variant.compare_at_price > variant.price;
          compare.hidden = !onSale;
          if (onSale) compare.textContent = this.formatMoney(variant.compare_at_price);
        }
        if (this.dataset.action === 'add') this.setButton(variant.available);
      }

      // Image de la variante (même recadrage que le Liquid : 80 et 160 px de large).
      updateImage(media) {
        const img = this.querySelector('[data-dx-sticky-image]');
        const src = media?.preview_image?.src;
        if (!img || !src) return;
        const sized = (w) => `${src}${src.includes('?') ? '&' : '?'}width=${w}`;
        img.srcset = `${sized(80)} 80w, ${sized(160)} 160w`;
        img.src = sized(160);
        img.alt = media.alt || '';
      }

      setButton(available) {
        this.button.disabled = !available;
        this.button.textContent = available ? this.dataset.label : this.dataset.soldOut;
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '{{amount}}';
        const number = (value, decimals, thousands, decimal) => {
          const [whole, fraction] = (value / 100).toFixed(decimals).split('.');
          return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
          if (key === 'amount_no_decimals') return number(cents, 0, ',', '.');
          if (key === 'amount_with_comma_separator') return number(cents, 2, '.', ',');
          if (key === 'amount_no_decimals_with_comma_separator') return number(cents, 0, '.', ',');
          if (key === 'amount_with_apostrophe_separator') return number(cents, 2, "'", '.');
          if (key === 'amount_with_space_separator') return number(cents, 2, ' ', ',');
          return number(cents, 2, ',', '.');
        });
      }
    }
  );
}
